@file:Suppress("unused")

package net.sergeych.ugdx.shared.api

import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable
import net.sergeych.kiloparsec.command


@Serializable
class UserSetDataArgs(val dataKey: String,val encryptedData:UByteArray)

@Serializable
class UserGetDataArgs(val dataKey: String)

@Serializable
class UserDataResult(val encryptedData:UByteArray,val createdAt: Instant)

val cmdUserSetData by command<UserSetDataArgs,Unit>("User.setData")
val cmdUserGetData by command<UserGetDataArgs, UserDataResult>("User.getData")
val cmdUserDropData by command<UserGetDataArgs, Unit>("User.dropData")
